// extracted by mini-css-extract-plugin
export var card = "_md-5";
export var cardSelected = "_md-4";
export var image = "_md-3";
export var modal = "_md-0";
export var modalContent = "_md-1";
export var table = "_md-2";